import { GState } from "IZOX/STATIC";

class ReqConfig {

  static async GetAccessToken(){
    return GState.user.JWT;
  }

  static async GetAddOns(){
    return {};
  }

  static AttachmentFieldKey = "__attachment__";
  static AttachmentLinkRef = "atth::";

}

export default ReqConfig;